<template>
    <b-row id="commissions_stats_component"
           class="commissions-stats-component">
        <b-col lg="3"
               cols="6"
               v-for="(stat, index) in stats"
               :key="index">
            <stats-item :label="stat.label"
                        :value="stat.value"></stats-item>
        </b-col>
    </b-row>
</template>

<script>
    import StatsItem from './commissions-stats/StatsItem.vue'
    export default {
        dependencies: ['money'],
        components: { StatsItem },
        computed: {
            businessBonusAmount () {
                return this.$store.getters.totalIncomes.business_bonus_income.amount
            },
            carBonusAmount () {
                return this.$store.getters.totalIncomes.car_bonus_income.amount
            },
            directBonusCareerLevelAmount () {
                return this.$store.getters.totalIncomes.direct_bonus_career_level_income.amount
            },
            directBonusPositionAmount () {
                return this.$store.getters.totalIncomes.direct_bonus_position_income.amount
            },
            matchingBonusAmount () {
                return this.$store.getters.totalIncomes.matching_bonus_income.amount
            },
            unilevelBonusCareerLevelAmount () {
                return this.$store.getters.totalIncomes.unilevel_bonus_career_level_income.amount
            },
            unilevelBonusPositionAmount () {
                return this.$store.getters.totalIncomes.unilevel_bonus_position_income.amount
            },
            stats () {
                return {
                    1: {
                        label: 'Income from<br>Direct Bonus:',
                        value: 'FND '   + this.money.format(this.directBonusPositionAmount, 'fnd')
                    },
                    2: {
                        label: 'Income from<br>Unilevel Bonus:',
                        value: 'FND '   + this.money.format(this.unilevelBonusPositionAmount, 'fnd')
                    },
                    3: {
                        label: 'Income from<br>Career Sponsor Bonus:',
                        value: 'FND '   + this.money.format(this.directBonusCareerLevelAmount, 'fnd')
                    },
                    4: {
                        label: 'Income from<br>Career Unilevel Bonus:',
                        value: 'FND '   + this.money.format(this.unilevelBonusCareerLevelAmount, 'fnd')
                    },
                    5: {
                        label: 'Income from<br>Matching Bonus:',
                        value: 'FND '   + this.money.format(this.matchingBonusAmount, 'fnd')
                    },
                    6: {
                        label: 'Income from<br>Car Bonus:',
                        value: 'FND '   + this.money.format(this.carBonusAmount, 'fnd')
                    },
                    7: {
                        label: 'Income from<br>Business Bonus:',
                        value: 'FND '   + this.money.format(this.businessBonusAmount, 'fnd')
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .commissions-stats-component{
        margin: 30px -15px 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/commissions/CommissionsStats.vue